import React from 'react';
import { Check, X, AlertCircle, TrendingUp, Clock, DollarSign } from 'lucide-react';
export function SalesLetter() {
  const scrollToPurchase = () => {
    document.getElementById('purchase')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <article id="sales-letter" className="max-w-4xl mx-auto px-4 space-y-0 text-lg md:text-xl leading-relaxed" data-id="element-113">
      {/* BLOQUE 1 */}
      <section className="space-y-6 text-center py-16 px-4 relative overflow-hidden" data-id="element-114">
        <div className="absolute inset-0 bg-gradient-to-br from-green-950 via-slate-900 to-black opacity-95" data-id="element-115" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-116" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,_rgba(34,197,94,0.1),_transparent_70%)]" data-id="element-117" />

        <div className="relative z-10" data-id="element-118">
          <p className="font-bold text-white text-2xl" data-id="element-119">
            Déjame preguntarte algo directo:
          </p>
          <p className="text-slate-300" data-id="element-120">
            ¿Cuántas veces llegaste a mitad de mes y pensaste:{' '}
            <span className="italic text-white font-semibold" data-id="element-121">
              "otra vez no alcanza"
            </span>
            ?
          </p>
          <p className="text-slate-300" data-id="element-122">
            Abrís el homebanking. Pagás alquiler, servicios, comida… Y el número
            baja más rápido de lo que entra.
          </p>
          <p className="text-slate-300" data-id="element-123">
            No es que no trabajes. No es que no te esfuerces. Es que el dinero
            nunca alcanza.
          </p>
          <p className="font-bold text-white text-xl" data-id="element-124">Y eso cansa.</p>
          <p className="text-slate-300" data-id="element-125">
            Cansa trabajar muchas horas y seguir igual. Cansa hacer "todo bien"
            y no avanzar. Cansa vivir con la sensación de estar siempre a una
            mala noticia del colapso.
          </p>
        </div>
      </section>

      {/* BLOQUE 2 */}
      <section className="relative overflow-hidden p-8 border-l-4 border-red-500 space-y-4" data-id="element-126">
        <div className="absolute inset-0 bg-gradient-to-br from-red-950/40 via-slate-900 to-slate-950" data-id="element-127" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/dark-matter.png')] opacity-30" data-id="element-128" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-red-500/5 rounded-full blur-3xl" data-id="element-129" />

        <div className="relative z-10" data-id="element-130">
          <p className="font-bold text-white mb-4 text-center text-xl" data-id="element-131">
            Si estás leyendo esto, probablemente estés cansado de:
          </p>
          <ul className="space-y-3 max-w-2xl mx-auto" data-id="element-132">
            {['Llegar justo (o no llegar) a fin de mes', 'Ver cómo todo sube menos tu ingreso', 'Trabajar cada vez más para ganar lo mismo', 'Sentir que el tiempo pasa y nada cambia'].map((item, i) => <li key={i} className="flex items-start gap-3 justify-center text-slate-300" data-id="element-133">
                <X className="w-6 h-6 text-red-400 shrink-0" data-id="element-134" />
                <span data-id="element-135">{item}</span>
              </li>)}
          </ul>
          <p className="pt-4 font-bold text-white text-center text-xl" data-id="element-136">
            Y lo peor de todo no es la plata. Es la sensación de no tener
            control.
          </p>
        </div>
      </section>

      {/* BLOQUE 3 */}
      <section className="space-y-6 text-center py-16 px-4 relative overflow-hidden" data-id="element-137">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-green-50 to-slate-200" data-id="element-138" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagmonds-light.png')] opacity-40" data-id="element-139" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-green-200/30 rounded-full blur-3xl" data-id="element-140" />

        <div className="relative z-10" data-id="element-141">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-6 tracking-wide leading-tight" data-id="element-142">
            EL PROBLEMA NO SOS VOS
          </h2>
          <p className="text-slate-700" data-id="element-143">
            Durante años nos hicieron creer que, si no avanzamos, es porque:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-slate-600 max-w-2xl mx-auto text-left" data-id="element-144">
            <li data-id="element-145">No somos lo suficientemente inteligentes</li>
            <li data-id="element-146">No tenemos "mentalidad"</li>
            <li data-id="element-147">No sabemos de tecnología</li>
            <li data-id="element-148">No nacimos para los negocios</li>
          </ul>
          <p className="text-xl font-bold text-green-600" data-id="element-149">
            Pero la verdad es otra.
          </p>
          <p className="text-slate-700" data-id="element-150">
            El problema no sos vos. El problema es el sistema.
          </p>
          <p className="text-slate-700" data-id="element-151">
            Mientras los precios suben, los sueldos se quedan quietos. Mientras
            trabajás más horas, tu ingreso no crece. Mientras cumplís reglas,
            otros avanzan.
          </p>
          <p className="text-slate-700" data-id="element-152">
            Y no porque sean mejores. Sino porque usan mejores herramientas.
          </p>
        </div>
      </section>

      {/* BLOQUE 4 */}
      <section className="space-y-6 text-center py-16 px-4 relative overflow-hidden border-y border-green-500/30" data-id="element-153">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-green-950/50 to-slate-900" data-id="element-154" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-155" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,_rgba(34,197,94,0.15),_transparent_60%)]" data-id="element-156" />
        <div className="absolute top-10 right-10 w-64 h-64 border border-green-500/20 rounded-full" data-id="element-157" />
        <div className="absolute bottom-10 left-10 w-48 h-48 border border-green-500/10 rounded-full" data-id="element-158" />

        <div className="relative z-10" data-id="element-159">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-wide leading-tight px-2" data-id="element-160">
            LA OPORTUNIDAD QUE MUCHOS ESTÁN IGNORANDO
          </h2>
          <p className="text-slate-300" data-id="element-161">
            Hoy existe una herramienta que está cambiando la forma de generar
            ingresos.
          </p>
          <p className="text-slate-300" data-id="element-162">
            No es magia. No es suerte. No es para genios ni programadores.
          </p>
          <p className="font-bold text-white text-2xl" data-id="element-163">
            Es para personas comunes.
          </p>
          <p className="font-display text-4xl sm:text-5xl md:text-6xl text-green-400 font-bold my-6 text-glow leading-tight" data-id="element-164">
            LA INTELIGENCIA ARTIFICIAL
          </p>
          <p className="text-slate-300" data-id="element-165">
            Pero usada de la forma correcta. No para complicarte la vida. Sino
            para simplificarla.
          </p>
          <p className="text-slate-300" data-id="element-166">
            No para que aprendas tecnología. Sino para que la uses como una
            palanca.
          </p>
          <p className="bg-slate-900/70 p-6 rounded-lg border border-green-500/30 italic max-w-2xl mx-auto text-xl text-slate-200 backdrop-blur-sm" data-id="element-167">
            "Como una calculadora. No necesitás saber cómo funciona por dentro.
            Solo necesitás saber qué botones apretar."
          </p>
        </div>
      </section>

      {/* BLOQUE 5 */}
      <section className="space-y-6 text-center py-16 px-4 relative overflow-hidden" data-id="element-168">
        <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 via-white to-orange-50" data-id="element-169" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/subtle-white-feathers.png')] opacity-50" data-id="element-170" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-200/20 rounded-full blur-3xl" data-id="element-171" />

        <div className="relative z-10" data-id="element-172">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-6 tracking-wide leading-tight" data-id="element-173">
            EL VERDADERO PROBLEMA
          </h2>
          <p className="text-slate-700" data-id="element-174">
            El problema nunca fue la falta de ganas. Ni la falta de tiempo. Ni
            la falta de inteligencia.
          </p>
          <div className="flex items-start gap-3 bg-gradient-to-br from-yellow-100 to-orange-50 p-6 rounded-xl border-2 border-yellow-400 max-w-3xl mx-auto shadow-lg" data-id="element-175">
            <AlertCircle className="w-8 h-8 text-yellow-600 shrink-0 mt-1" data-id="element-176" />
            <div className="text-left" data-id="element-177">
              <p className="font-bold text-yellow-700 text-xl mb-2" data-id="element-178">
                👉 El problema fue no tener un sistema simple, guiado y
                actualizado.
              </p>
              <p className="text-slate-700" data-id="element-179">
                Por eso tanta gente prueba cosas y fracasa:
              </p>
              <ul className="mt-4 space-y-2 text-base text-slate-600" data-id="element-180">
                <li data-id="element-181">• Cursos llenos de teoría</li>
                <li data-id="element-182">• Gurús prometiendo miles de dólares</li>
                <li data-id="element-183">• Videos sueltos de YouTube que confunden más</li>
                <li data-id="element-184">• Negocios que requieren inversión y tiempo completo</li>
              </ul>
            </div>
          </div>
          <p className="font-bold text-slate-900 text-xl" data-id="element-185">
            Resultado: frustración, pérdida de tiempo y cero resultados.
          </p>
          <p className="text-xl text-slate-700" data-id="element-186">
            No fallaste vos. Fallaron los métodos.
          </p>
        </div>
      </section>

      {/* BLOQUE 6 */}
      <section className="space-y-6 text-center py-16 px-4 relative overflow-hidden" data-id="element-187">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-green-950/30 to-slate-950" data-id="element-188" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/dark-matter.png')] opacity-20" data-id="element-189" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(34,197,94,0.1),_transparent_70%)]" data-id="element-190" />

        <div className="relative z-10" data-id="element-191">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 tracking-wide leading-tight" data-id="element-192">
            IMAGINATE ESTO
          </h2>
          <p className="text-slate-300" data-id="element-193">
            Imaginá abrir el celular y ver ingresos nuevos.
          </p>
          <p className="text-slate-300" data-id="element-194">
            No dependen de tu jefe. No dependen de horarios. No dependen de
            suerte.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-195">
            {['Un ingreso extra real', 'Algo que podés hacer desde casa', 'Algo que entendés', 'Algo que controlás'].map((item, i) => <div key={i} className="bg-gradient-to-br from-green-900/40 to-green-950/20 p-4 rounded-lg flex items-center gap-3 border border-green-500/30 justify-center backdrop-blur-sm" data-id="element-196">
                <Check className="w-5 h-5 text-green-400" data-id="element-197" />
                <span className="font-medium text-white" data-id="element-198">{item}</span>
              </div>)}
          </div>
          <p className="text-xl text-slate-300" data-id="element-199">
            No para "hacerte millonario en 7 días". Sino para respirar
            tranquilo, recuperar el control y avanzar.
          </p>
        </div>
      </section>

      {/* BLOQUE 7 */}
      <section className="relative overflow-hidden p-8 md:p-12 border-2 border-green-500 shadow-2xl text-center" data-id="element-200">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-100 via-green-50 to-slate-100" data-id="element-201" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagmonds-light.png')] opacity-30" data-id="element-202" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(34,197,94,0.1),_transparent_70%)]" data-id="element-203" />
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-400 via-green-500 to-green-400" data-id="element-204" />

        <div className="relative z-10" data-id="element-205">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-6 tracking-wide leading-tight" data-id="element-206">
            PRESENTACIÓN DEL SISTEMA
          </h2>
          <h3 className="font-display text-2xl sm:text-3xl md:text-4xl font-black text-green-600 mb-8 uppercase tracking-wider leading-tight" data-id="element-207">
            CÓMO EMPEZAR A GANAR DINERO EXTRA YA
          </h3>
          <p className="mb-6 text-slate-700" data-id="element-208">
            Es un sistema práctico, paso a paso, que te muestra cómo usar la
            inteligencia artificial para generar ingresos extra de forma simple
            y realista.
          </p>
          <p className="font-bold text-slate-900 mb-4 text-xl" data-id="element-209">
            Está pensado para personas reales:
          </p>
          <ul className="space-y-3 mb-8 max-w-2xl mx-auto" data-id="element-210">
            {['Sin conocimientos técnicos', 'Sin experiencia en negocios online', 'Con trabajo, responsabilidades y poco tiempo', 'Que usan el celular todos los días'].map((item, i) => <li key={i} className="flex items-center gap-3 justify-center text-slate-700" data-id="element-211">
                <Check className="w-5 h-5 text-green-600" data-id="element-212" />
                <span data-id="element-213">{item}</span>
              </li>)}
          </ul>
          <p className="font-bold text-slate-900 text-xl border-t-2 border-green-500/30 pt-6" data-id="element-214">
            Sin humo. Sin promesas irreales. Sin complicarte la vida.
          </p>
        </div>
      </section>

      {/* BLOQUE 8 */}
      <section className="space-y-6 text-center py-16 px-4 relative overflow-hidden" data-id="element-215">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-black" data-id="element-216" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-217" />
        <div className="absolute inset-0" style={{
        backgroundImage: 'linear-gradient(rgba(34,197,94,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(34,197,94,0.03) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }} data-id="element-218" />

        <div className="relative z-10" data-id="element-219">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 tracking-wide leading-tight" data-id="element-220">
            CÓMO FUNCIONA
          </h2>
          <p className="text-slate-300" data-id="element-221">
            En lugar de tirarte información suelta, este sistema te muestra:
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto" data-id="element-222">
            {[{
            icon: <Check className="w-8 h-8" data-id="element-223" />,
            text: 'Qué hacer'
          }, {
            icon: <TrendingUp className="w-8 h-8" data-id="element-224" />,
            text: 'En qué orden'
          }, {
            icon: <Clock className="w-8 h-8" data-id="element-225" />,
            text: 'Con qué herramientas'
          }, {
            icon: <DollarSign className="w-8 h-8" data-id="element-226" />,
            text: 'Cómo ejecutar'
          }].map((item, i) => <div key={i} className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 p-6 rounded-xl border border-green-500/20 flex flex-col items-center gap-3 backdrop-blur-sm" data-id="element-227">
                <div className="text-green-400" data-id="element-228">{item.icon}</div>
                <span className="font-bold text-white" data-id="element-229">{item.text}</span>
              </div>)}
          </div>
          <p className="font-bold text-white text-xl mt-6" data-id="element-230">Paso a paso.</p>
          <p className="text-slate-300" data-id="element-231">
            Usando la inteligencia artificial como un asistente 24/7 que hace el
            trabajo pesado mientras vos decidís.
          </p>
          <p className="text-green-400 font-medium italic text-xl" data-id="element-232">
            Es como pasar de cavar con una pala a usar una excavadora. El
            esfuerzo es el mismo. El resultado no.
          </p>
        </div>
      </section>

      {/* BLOQUE 9 - Tabla */}
      <section className="space-y-8 text-center py-16 px-4 relative overflow-hidden" data-id="element-233">
        <div className="absolute inset-0 bg-gradient-to-br from-white via-slate-50 to-green-50" data-id="element-234" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/subtle-white-feathers.png')] opacity-40" data-id="element-235" />

        <div className="relative z-10" data-id="element-236">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-8 tracking-wide leading-tight" data-id="element-237">
            POR QUÉ ESTO ES DIFERENTE
          </h2>

          <div className="max-w-4xl mx-auto overflow-x-auto" data-id="element-238">
            <table className="w-full border-collapse bg-white/80 backdrop-blur-sm rounded-xl overflow-hidden shadow-xl" data-id="element-239">
              <thead data-id="element-240">
                <tr className="border-b-2 border-green-600" data-id="element-241">
                  <th className="p-4 text-left text-slate-600 font-normal" data-id="element-242">
                    Característica
                  </th>
                  <th className="p-4 text-center bg-gradient-to-br from-red-50 to-red-100 border-l border-slate-300" data-id="element-243">
                    <span className="text-red-600 font-bold" data-id="element-244">Otros Cursos</span>
                  </th>
                  <th className="p-4 text-center bg-gradient-to-br from-green-50 to-green-100 border-l border-slate-300" data-id="element-245">
                    <span className="text-green-600 font-bold" data-id="element-246">
                      Este Sistema
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-base" data-id="element-247">
                {['Promesas realistas', 'Sin conocimientos previos', 'Sin inversión inicial', 'Explicado para gente común', 'Paso a paso claro'].map((feature, i) => <tr key={i} className="border-b border-slate-200" data-id="element-248">
                    <td className="p-4 text-left font-medium text-slate-900" data-id="element-249">
                      {feature}
                    </td>
                    <td className="p-4 text-center bg-red-50/50 border-l border-slate-300" data-id="element-250">
                      <X className="w-6 h-6 text-red-600 mx-auto" data-id="element-251" />
                    </td>
                    <td className="p-4 text-center bg-green-50/50 border-l border-slate-300" data-id="element-252">
                      <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-253" />
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <p className="font-bold text-slate-900 text-xl mt-8" data-id="element-254">
            Acá no tenés que "entender todo". Tenés que empezar.
          </p>
        </div>
      </section>

      {/* BLOQUE 10 - Historia */}
      <section className="relative overflow-hidden py-16 px-4" data-id="element-255">
        <div className="absolute inset-0 bg-gradient-to-br from-green-900 via-slate-900 to-blue-950" data-id="element-256" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/dark-matter.png')] opacity-30" data-id="element-257" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,_rgba(34,197,94,0.2),_transparent_60%)]" data-id="element-258" />
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-500 via-yellow-500 to-green-500" data-id="element-259" />

        <div className="relative space-y-6 p-8 md:p-12 text-center max-w-3xl mx-auto z-10" data-id="element-260">
          <div className="inline-block px-4 py-2 bg-green-500/20 border border-green-500/50 rounded-full mb-4 backdrop-blur-sm" data-id="element-261">
            <span className="text-green-400 font-bold text-sm uppercase tracking-wider" data-id="element-262">
              Historia Real
            </span>
          </div>

          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 tracking-wide leading-tight" data-id="element-263">
            POR QUÉ EXISTE ESTE SISTEMA
          </h2>

          <div className="space-y-6 text-lg" data-id="element-264">
            <p className="text-slate-300" data-id="element-265">
              Este sistema no nació desde el éxito.
            </p>
            <p className="text-slate-300" data-id="element-266">
              Nació desde la frustración. De estar justo. De probar cosas que no
              funcionaban. De ver siempre el mismo resultado.
            </p>

            <div className="bg-slate-800/50 border-l-4 border-green-500 p-6 rounded-r-xl my-8 backdrop-blur-sm" data-id="element-267">
              <p className="font-serif italic text-2xl text-white" data-id="element-268">
                "¿Y si la tecnología no es el problema… sino la forma en que nos
                la explican?"
              </p>
            </div>

            <p className="text-slate-300" data-id="element-269">
              Ahí empezó todo. Probando. Simplificando. Sacando el humo.
            </p>
            <p className="font-bold text-white text-xl" data-id="element-270">
              Hasta convertirlo en un sistema claro, entendible y aplicable.
            </p>
          </div>
        </div>
      </section>

      {/* BLOQUE 11 */}
      <section className="space-y-6 text-center py-16 px-4 relative overflow-hidden" data-id="element-271">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-green-50" data-id="element-272" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/diagmonds-light.png')] opacity-30" data-id="element-273" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-200/20 rounded-full blur-3xl" data-id="element-274" />

        <div className="relative z-10" data-id="element-275">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 mb-6 tracking-wide leading-tight" data-id="element-276">
            LA PROMESA
          </h2>
          <p className="text-xl max-w-3xl mx-auto text-slate-700" data-id="element-277">
            Personas comunes están generando ingresos extra reales usando
            inteligencia artificial, incluso empezando desde cero y sin
            experiencia previa.
          </p>
          <p className="font-bold text-slate-900 text-xl" data-id="element-278">
            No porque sean expertos. Sino porque usan un sistema simple.
          </p>
        </div>
      </section>

      {/* BLOQUE 12 - Final */}
      <section className="space-y-8 text-center py-16 px-4 relative overflow-hidden border-t-4 border-green-500" data-id="element-279">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-green-950/40 to-black" data-id="element-280" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-281" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(34,197,94,0.15),_transparent_70%)]" data-id="element-282" />

        <div className="relative z-10" data-id="element-283">
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 tracking-wide leading-tight" data-id="element-284">
            SI LLEGASTE HASTA ACÁ
          </h2>
          <p className="text-slate-300" data-id="element-285">
            Probablemente estés cansado. Cansado de trabajar y no avanzar.
            Cansado de promesas vacías. Cansado de sentir que el dinero nunca
            alcanza.
          </p>
          <p className="font-bold text-white text-xl" data-id="element-286">
            Y la pregunta no es si querés cambiar.
          </p>
          <p className="text-2xl text-slate-200" data-id="element-287">La pregunta es:</p>
          <p className="font-display text-3xl sm:text-4xl md:text-5xl font-black text-white my-4 tracking-wide leading-tight px-2" data-id="element-288">
            ¿VAS A SEGUIR ESPERANDO… O VAS A EMPEZAR AHORA?
          </p>

          <button onClick={scrollToPurchase} className="bg-gradient-to-r from-green-600 to-green-500 hover:from-green-500 hover:to-green-400 text-white text-xl font-bold py-4 px-12 rounded-full shadow-lg shadow-green-900/30 transition-all transform hover:scale-105 animate-pulse" data-id="element-289">
            SÍ, QUIERO EMPEZAR HOY
          </button>
        </div>
      </section>
    </article>;
}